import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import useHomeContext from 'Context/HomeContext';
import New from './new';
import Old from './old';

const PersonalInfoPicker = (props) => {
  const { homeResource } = useHomeContext();
  const Component = pick(homeResource, {
    [fr.relationships.onlyLoginEmailAddress.name]: New,
  }, Old);

  return <Component {...props} />;
};

export default PersonalInfoPicker;
